import { LinkLabelCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedModelConceptRelationshipLabel,
  ModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createDeletedModelConceptClass';

export const replaceDeletedModelConceptRelationshipLabelKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL}-`),
    `${LinkLabelCategory.DELETED_MODEL_CONCEPT_RELATIONSHIP_LABEL}-`
  );

export const createDeletedModelConceptRelationshipLabel = (
  existing: ModelConceptRelationshipLabel,
  label: string,
  deletedKeys: Set<string>
): DeletedModelConceptRelationshipLabel => ({
  key: replaceDeletedModelConceptRelationshipLabelKey(existing.key),
  from:
    existing.from && deletedKeys.has(existing.from)
      ? replaceDeletedModelConceptClassKey(existing.from)
      : existing.from,
  value: existing.value,
  text: label,
  to:
    existing.to && deletedKeys.has(existing.to)
      ? replaceDeletedModelConceptClassKey(existing.to)
      : existing.to,
  category: LinkLabelCategory.DELETED_MODEL_CONCEPT_RELATIONSHIP_LABEL,
});
